import React from "react";
import { assetUrl } from "fusion-core";

const marks = {
  "on-navy": assetUrl("../../assets/branding/dis-mark-on-navy.svg"),
  "on-white": assetUrl("../../assets/branding/dis-mark-on-white.svg"),
  "one-colour-navy": assetUrl(
    "../../assets/branding/dis-mark-one-colour-navy.svg",
  ),
};

const DriverInsuranceLogo = ({
  href = "/taxi/quote",
  variant = "on-navy",
  size = "default",
  className = "",
}) => {
  const BrandElement = href ? "a" : "div";
  const isCompact = size === "compact";
  const variantStyles = {
    "on-navy": "tw-text-white",
    "on-white": "tw-text-dis-navy",
    "one-colour-navy": "tw-text-dis-navy",
  };
  const subColor =
    variant === "on-navy" ? "tw-text-dis-sky-pale" : "tw-text-dis-text-muted";
  const poweredByColor =
    variant === "one-colour-navy" ? "tw-text-inherit" : "tw-text-dis-sky";

  return (
    <BrandElement
      className={`tw-flex tw-min-h-11 tw-items-center tw-gap-2 tw-no-underline md:tw-gap-2.5 ${variantStyles[variant] || variantStyles["on-navy"]} ${className}`.trim()}
      {...(href ? { href } : {})}
      aria-label="Driver Insurance Services"
    >
      <img
        className={`tw-block tw-flex-none tw-object-contain ${isCompact ? "tw-h-8 tw-w-[42px]" : "tw-h-8 tw-w-[41px] md:tw-h-[42px] md:tw-w-[54px]"}`}
        src={marks[variant] || marks["on-navy"]}
        alt=""
      />
      <span className={`tw-flex tw-flex-col ${isCompact ? "tw-gap-0" : "tw-gap-0.5"}`}>
        <span className={`tw-block tw-whitespace-nowrap tw-font-semibold tw-leading-[1.05] tw-tracking-[-0.02em] ${isCompact ? "tw-text-base md:tw-text-[17px]" : "tw-text-[15px] md:tw-text-[20px] md:tw-leading-[1.05]"}`} translate="no">
          <b className="tw-font-extrabold">Driver</b> Insurance Services
        </span>
        <span className={`tw-whitespace-nowrap tw-text-[11.5px] tw-leading-[1.2] md:tw-text-[13px] ${subColor}`}>
          powered by <b className={`tw-font-bold ${poweredByColor}`}>Freeway</b>
        </span>
      </span>
    </BrandElement>
  );
};

export default DriverInsuranceLogo;
